import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {routes} from "../../../core/models/static/routes/app-routes";
import PhoneStripeCardSetupView from "./phone-stripe-card-setup";
import PhoneStripeCardSetupClientSideView from "./phone-stripe-card-setup-client-side";

const PublicViews = () => {

    return (
        <>
            <Switch>
                <Route path={routes.public.phoneStripeCardSetup} exact>
                    <PhoneStripeCardSetupView/>
                </Route>
                <Route path={routes.public.phoneStripeCardSetupClientSide} exact>
                    <PhoneStripeCardSetupClientSideView/>
                </Route>
                <Redirect to={routes.error.notFound}/>
            </Switch>
        </>

    );
};

export default PublicViews;
